import {
  BarChart,
  Bold,
  Capacity,
  CheckboxSelected,
  Image,
  Navigate,
} from 'grommet-icons';

export const structure = [
  {
    name: 'Layout',
    Icon: Capacity,
    components: [
      'Box',
      'Grid',
      'Page',
      'PageContent',
      'PageHeader',
      'Main',
      'Nav',
      'Header',
      'Footer',
      'Sidebar',
      'Card',
      'CardHeader',
      'CardBody',
      'CardFooter',
      'Stack',
      'Layer',
    ],
  },
  {
    name: 'Typography',
    Icon: Bold,
    components: ['Heading', 'Paragraph', 'Text', 'Markdown'],
  },
  {
    name: 'Controls',
    Icon: Navigate,
    components: [
      'Accordion',
      'AccordionPanel',
      'Anchor',
      'Button',
      'DropButton',
      'Menu',
      'Tabs',
      'Tab',
      'Tip',
      'ToggleGroup',
    ],
  },
  {
    name: 'Input',
    Icon: CheckboxSelected,
    components: [
      'CheckBox',
      'CheckBoxGroup',
      'DateInput',
      'FileInput',
      'Form',
      'FormField',
      'MaskedInput',
      'RadioButtonGroup',
      'RangeInput',
      'Select',
      'SelectMultiple',
      'StarRating',
      'TextArea',
      'TextInput',
      'ThumbsRating',
    ],
  },
  {
    name: 'Visualizations',
    Icon: BarChart,
    components: [
      'Avatar',
      'Calendar',
      'Cards',
      'Chart',
      'Clock',
      'Data',
      'DataChart',
      'DataClearFilters',
      'DataFilter',
      'DataFilters',
      'DataSearch',
      'DataSort',
      'DataSummary',
      'DataTable',
      'DataTableColumns',
      'DataTableGroupBy',
      'DataView',
      'Diagram',
      'Distribution',
      'List',
      'Meter',
      'NameValueList',
      'NameValuePair',
      'Notification',
      'Pagination',
      'Spinner',
      'Tag',
      'Toolbar',
      'WorldMap',
    ],
  },
  {
    name: 'Media',
    Icon: Image,
    components: ['Carousel', 'Image', 'Video'],
  },
];
